<template>

  <div class="vflex">
    <div class="vflex-row-0 px-3 pt-3">
      <div class="alert alert-info mb-0">
        <i class="fas fa-info-circle mr-1" />
        {{ $t('A more advanced career site builder is available. This page is dedicated to the legacy editing of career pages.') }}
        <router-link to="/config/careersites">{{ $t('Go to career sites') }} <i class="fas fa-arrow-right" /></router-link>
      </div>
    </div>
    <div class="vflex-row-0 pt-3">
      <ul class="nav nav-tabs">
        <li class="nav-item pl-3">
          <router-link
            class="nav-link"
            :class="{active: currentRoute === '/config/careerpage/pages'}"
            to="/config/careerpage/pages">{{ $t('Pages') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: currentRoute === '/config/careerpage/config'}"
            to="/config/careerpage/config">{{ $t('Settings') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: currentRoute === '/config/careerpage/social'}"
            to="/config/careerpage/social">{{ $t('Social') }}</router-link>
        </li>
      </ul>
    </div>
    <div class="vflex-row-1">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Careerpage',
  computed: {
    currentRoute () {
      return this.$route.path
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Careerpage/Careerpage.vue